import { render, staticRenderFns } from "./document-tracking.vue?vue&type=template&id=11585168&"
import script from "./document-tracking.vue?vue&type=script&lang=js&"
export * from "./document-tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports